import {Component, OnInit, Input} from '@angular/core';
import {IsFilterOnService} from '../../../../Services/is-filter-on.service';

@Component({
  selector: 'app-entity-state-select',
  templateUrl: './entity-state-select.component.html',
  styleUrls: ['./entity-state-select.component.css'],
  standalone: false
})
export class EntityStateSelectComponent implements OnInit {
  @Input() vm: any;

  constructor(public isFiltered: IsFilterOnService) {
  }

  ngOnInit() {
  }

  checkFiltered(): boolean {
    const filteredValue = this.isFiltered.isFiltered(this.vm);
    this.vm.filtered = filteredValue;
    return filteredValue;
  }

}
